<template>
  <div>
    <section v-if="modalVisible">
      <user-manager-item
        :modal-visible="modalVisible"
        :user-id="userId"
        @close="closeModal"
        @save="closeAndRefresh"
      />
    </section>
    <assign-to-client-form
      v-if="assignToClientModalVisible"
      :assign-to-client-modal-visible="assignToClientModalVisible"
      @close="toggleAssignToClientModal"
      @save="closeAndRefresh"
    />
    <section v-show="!modalVisible">
      <page-toolbar>
        <kendo-button icon="add" title="Add new" class="createUserButton"> </kendo-button>
        <div class="exportButton"></div>
        <v-switch v-model="showActive" :label="`Show Inactive`" @change="refreshGrid"></v-switch>
        <span style="padding:4px"></span>
        <kendo-button
          icon="user"
          title="Assign Users to Client."
          v-if="currentRole == 'SuperAdmin'"
          @click="toggleAssignToClientModal"
        >
        </kendo-button>
      </page-toolbar>
      <div ref="grid" style="height: calc(100vh - 160px)"></div>
    </section>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import $ from '../helpers/jquery-bridge'
import UserManagerItem from './templates/UserManagerItem'
import {enableExportExcel} from '../helpers/export-helper'
import {createCheckboxColumn} from '../helpers/kendo-editors'
import AssignToClientForm from '../views/UserManager/AssignToClientForm'
import PageToolbar from '@/components/PageToolbar'

export default {
  components: {
    UserManagerItem,
    PageToolbar,
    AssignToClientForm,
  },
  data() {
    return {
      userId: null,
      modalVisible: false,
      showActive: false,
      assignToClientModalVisible: false,
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({currentRole: 'authentication/currentRole'}),
  },
  methods: {
    refreshGrid: function() {
      let grid = $(this.$refs.grid).data('kendoGrid')
      return grid.dataSource.read()
    },
    openModal(userId) {
      this.modalVisible = true
      this.userId = userId
    },
    closeModal() {
      this.userId = null
      this.modalVisible = false
    },
    closeAndRefresh() {
      this.refreshGrid()
    },
    toggleAssignToClientModal() {
      this.assignToClientModalVisible = !this.assignToClientModalVisible
    },
  },
  mounted() {
    let grid = $(this.$refs.grid)
      .kendoGrid({
        dataSource: new kendo.data.DataSource({
          type: 'aspnetmvc-ajax',
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          pageSize: 15,
          transport: {
            create: {
              type: 'POST',
              url: '/api/accounts',
              dataType: 'json',
            },
            read: {
              type: 'GET',
              url: '/api/accounts',
              dataType: 'json',
              data: () => ({showActive: this.showActive, clientId: this.clientId}),
            },
            update: {
              type: 'PUT',
              url: '/api/accounts',
              dataType: 'json',
            },
            destroy: {
              type: 'DELETE',
              url: '/api/accounts',
              data: () => {
                return {
                  clientId: this.clientId,
                }
              },
              dataType: 'json',
            },
          },
          schema: {
            data: 'data',
            errors: 'errors',
            total: 'total',
            model: {
              id: 'userId',
              fields: {
                Email: {field: 'email', type: 'string', validation: {required: true}},
                Username: {field: 'userName', type: 'string', validation: {required: true}},
                PhoneNumber: {field: 'phoneNumber', type: 'string', validation: {required: true}},
                FirstName: {field: 'firstName', type: 'string', validation: {required: true}},
                LastName: {field: 'lastName', type: 'string', validation: {required: true}},
                CreationDate: {field: 'creationDate', type: 'date', editable: false},
                LastLogin: {field: 'lastLogin', type: 'date', editable: false},
                LastUser: {field: 'lastUser', type: 'string', editable: false},
                LastModified: {field: 'lastModified', type: 'date', editable: false},
                DefaultClient: {type: 'string', field: 'defaultClient'},
                Role: {field: 'role', type: 'string', editable: false},
                IsActive: {type: 'bool', field: 'isActive'},
              },
            },
          },
        }),
        editable: 'inline',
        navigatable: true,
        filterable: true,
        sortable: true,
        pageable: true,
        edit: e => {
          const userId = e.model.id || 0
          this.openModal(userId)

          e.preventDefault()
          grid.cancelRow()
        },
        columns: [
          {
            command: [
              {
                name: 'edit',
                //visible: security.Role === "ADMINISTRATOR" ? function (dataItem) {
                //    return dataItem.Role.toUpperCase() !== "SUPERADMINISTRATOR";
                //} : function () { return true; }
              },
            ],
            title: '&nbsp;',
            width: 80,
            attributes: {style: 'text-align: center;'},
          },
          createCheckboxColumn($(this.$refs.grid), 'IsActive', {title: 'Active', width: 120}, true),
          {
            title: 'Username',
            field: 'Username',
            hidden: true,
          },
          {
            title: 'Email',
            field: 'Email',
            width: 190,
          },
          {
            title: 'Name',
            field: 'LastName',
            width: 182,
            template: '#=FirstName# #=LastName#',
          },
          {
            title: 'Role',
            field: 'Role',
            width: 150,
          },
          {
            title: 'Divisions',
            field: 'divisions',
            width: 350,
            attributes: {class: 'truncate-grid-column-text'},
            template:
              "#=(divisions || []).map(function (el) { return el.divisionName;}).join(', ')#",
          },
          {
            title: 'Clients',
            field: 'clients',
            width: 350,
            attributes: {class: 'truncate-grid-column-text'},
            template: "#=(clients || []).map(function (el) { return el.clientName;}).join(', ')#",
          },
          {
            title: 'Default Client',
            field: 'DefaultClient',
            width: 190,
          },
          {
            title: 'Markets',
            field: 'markets',
            width: 350,
            template: "#=(markets || []).map(function (el) { return el.market;}).join(', ')#",
          },
          {
            field: 'CreationDate',
            title: 'Creation Date',
            width: 150,
            attributes: {style: 'text-align: right;'},
            format: '{0:yyyy-MM-dd}',
            template: '#= kendo.toString(CreationDate ||"", "yyyy-MM-dd") #',
          },
          {
            field: 'LastLogin',
            title: 'Last Login',
            width: 180,
            attributes: {style: 'text-align: right;'},
            format: '{0:yyyy-MM-dd hh:mm:ss}',
            template: '#= kendo.toString(LastLogin||"", "yyyy-MM-dd hh:mm:ss") #',
          },
          {
            title: 'Last Modified',
            field: 'LastModified',
            width: 160,
            attributes: {style: 'text-align: right;'},
            format: '{0:yyyy-MM-dd}',
            template: '#= kendo.toString(LastModified || "", "yyyy-MM-dd") #',
          },
          {
            title: 'Last Modified By',
            field: 'LastUser',
            width: 190,
          },
          {
            command: ['destroy'],
            title: 'Delete',
            width: 80,
            attributes: {style: 'text-align: center;'},
          },
        ],
      })
      .getKendoGrid()

    let pageToolbar = $('.page_toolbar-item')
    let excelContainer = pageToolbar.find('.exportButton')
    enableExportExcel(grid, '/api/accounts/exportToExcel', excelContainer)

    var buttonElement = pageToolbar.find('.createUserButton')
    buttonElement.on('click', () => {
      this.openModal(0)
    })
  },
  beforeDestroy() {
    let grid = $(this.$refs.grid).getKendoGrid()
    if (grid) grid.destroy()
  },
}
</script>
<style>
.k-edit-form-container {
  width: 100% !important;
}
</style>
